import React from 'react';
import { useHttpClient } from '../hooks/useHttpClient';
import { usePreventDoubleClick } from '../hooks/usePreventDoubleClick';
import { useNotificacoes } from '../hooks/useNotificacoes';

/**
 * Envia o faturamento para a contabilidade por e-mail.
 *
 * @param {Object}   props
 * @param {Object}   props.filtros  { idUsina, idCliente|null, mes, ano }
 * @param {Number[]} props.idsConsumo (array ou null) – opcional
 */
export default function BotaoEmailEconomiaCliente({
                                                    filtros,
                                                    idsConsumo = null,
                                                    className = '',
                                                    children
                                                }) {
    const { post }         = useHttpClient();
    const { exibirErro, exibirSucesso } = useNotificacoes();
    const [safeClick, busy] = usePreventDoubleClick(handler);

    async function handler() {
        try {
            const body = {
                idsConsumo,
                usinaId  : filtros.idUsina,
                clienteId: filtros.idCliente || null,
                mes      : filtros.mes,
                ano      : filtros.ano
            };

            await post('/hello-sol/relatorios-economia-mensal/enviar', body);
            exibirSucesso('Relatório enviado para o Cliente');
        } catch (err) {
            exibirErro(err.message || 'Falha ao enviar e-mail');
        }
    }

    return (
        <button
            type="button"
            className={className}
            onClick={safeClick}
            disabled={busy}
            title={"Envia o relatório em PDF para o email do Cliente."}
            style={{ background:'none', border:'none', padding:0,
                color:'#28a745', cursor: busy ? 'wait' : 'pointer' }}
        >
            {busy ? '…' : children}
        </button>
    );
}
